import { Alert } from "react-bootstrap";
import DefaultSlide from "../../components/Slides/templates/DefaultSlide";
import ImageSlide from "../../components/Slides/templates/ImageSlide";
import TitleSlide from "../../components/Slides/templates/TitleSlide";
import StudentPicker from "../../components/global/StudentPicker";
import { ISlideObject } from "../../components/Slides/templates/ISlideObject";
import CodeSlide from "../../components/Slides/templates/CodeSlide";
import CodePen from "../../components/Codepen/Codepen";

export default function S02P02({ reveal }: ISlideObject) {
  return (
    <>
      <TitleSlide
        title="TI8512 - Desarrollo Ágil de Aplicaciones Web"
        subtitle="Semana 02 Parte 2"
      />
      <DefaultSlide title="Agenda">
        <div>
          <ul>
            <li>Repaso de HTML</li>
            <li>HTML en profundidad</li>
            <li>Introducción a CSS</li>
            <li>Mejores prácticas con HTML y CSS</li>
            <li>Ejercicios de HTML y CSS</li>
            <li>Ejercicio: to-do app</li>
          </ul>
        </div>
      </DefaultSlide>
      <section>
        <TitleSlide title="Repaso de HTML" />
        <DefaultSlide title="Repaso HTML">
          <div style={{ width: "100%", fontSize: "0.7em" }}>
            <p>
              La tarea era escoger al menos 10 elementos de HTML y utilizarlos
              en un archivo index.html. Describa uno de los elementos escogidos:
            </p>
            <StudentPicker number={2} />
          </div>
        </DefaultSlide>
        <DefaultSlide title="Repaso HTML">
          <div style={{ width: "100%", fontSize: "0.7em" }}>
            <p>
              ¿Para qué sirve la etiqueta <code>&lt;head&gt;&lt;/head&gt;</code>
              ?
            </p>
            <StudentPicker number={1} />
          </div>
        </DefaultSlide>

        <DefaultSlide title="Repaso HTML">
          <div style={{ width: "100%", fontSize: "0.7em" }}>
            <p>
              ¿Para qué sirve la etiqueta <code>&lt;body&gt;&lt;/body&gt;</code>
              ?
            </p>
            <StudentPicker number={1} />
          </div>
        </DefaultSlide>
      </section>
      <section>
        <TitleSlide title="Elementos de HTML" />
        <DefaultSlide title="Elementos de encabezado">
          <div style={{ width: "100%", fontSize: "0.85em" }}>
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Elemento</th>
                  <th>Descripción</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>&lt;h1&gt;&lt;/h1&gt;</td>
                  <td>
                    Encabezado principal, se usa para títulos importantes.
                  </td>
                </tr>
                <tr>
                  <td>&lt;h2&gt;&lt;/h2&gt;</td>
                  <td>Encabezado de segundo nivel, se usa para subtítulos.</td>
                </tr>
                <tr>
                  <td>&lt;h3&gt;&lt;/h3&gt;</td>
                  <td>
                    Encabezado de tercer nivel, se usa para secciones dentro de
                    subtítulos.
                  </td>
                </tr>
                <tr>
                  <td>&lt;h4&gt;&lt;/h4&gt;</td>
                  <td>Encabezado de cuarto nivel, se usa para subsecciones.</td>
                </tr>
                <tr>
                  <td>&lt;h5&gt;&lt;/h5&gt;</td>
                  <td>
                    Encabezado de quinto nivel, se usa para subsecciones
                    menores.
                  </td>
                </tr>
                <tr>
                  <td>&lt;h6&gt;&lt;/h6&gt;</td>
                  <td>
                    Encabezado de sexto nivel, se usa para las subsecciones más
                    pequeñas.
                  </td>
                </tr>
              </tbody>
            </table>
            <p className="fragment">
              El tamaño del texto no necesariamente está asociado a la
              relevancia del título
            </p>
          </div>
          <div>
            <h1>Esto es un H1</h1>
            <h3>Esto es un H3</h3>
            <h6>Esto es un H6</h6>
          </div>
        </DefaultSlide>
        <DefaultSlide title="Elementos de texto">
          <div style={{ width: "100%", fontSize: "0.85em" }}>
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Elemento</th>
                  <th>Descripción</th>
                  <th>Ejemplo</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>&lt;p&gt;&lt;/p&gt;</td>
                  <td>Párrafo de texto.</td>
                  <td>
                    <p>Este es un párrafo.</p>
                  </td>
                </tr>
                <tr>
                  <td>&lt;a href="url"&gt;&lt;/a&gt;</td>
                  <td>Enlace a otra página o recurso.</td>
                  <td>
                    <a href="#">Este es un enlace</a>
                  </td>
                </tr>
                <tr>
                  <td>&lt;ul&gt;&lt;/ul&gt;</td>
                  <td>Lista desordenada.</td>
                  <td>
                    <ul>
                      <li>Elemento 1</li>
                      <li>Elemento 2</li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <td>&lt;ol&gt;&lt;/ol&gt;</td>
                  <td>Lista ordenada.</td>
                  <td>
                    <ol>
                      <li>Elemento 1</li>
                      <li>Elemento 2</li>
                    </ol>
                  </td>
                </tr>
                <tr>
                  <td>&lt;li&gt;&lt;/li&gt;</td>
                  <td>Elemento de lista.</td>
                  <td>
                    <li>Elemento de lista</li>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div>
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Elemento</th>
                  <th>Descripción</th>
                  <th>Ejemplo</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>&lt;strong&gt;&lt;/strong&gt;</td>
                  <td>Texto en negrita (semántico).</td>
                  <td>
                    <strong>Texto en negrita</strong>
                  </td>
                </tr>
                <tr>
                  <td>&lt;em&gt;&lt;/em&gt;</td>
                  <td>Texto en cursiva (semántico).</td>
                  <td>
                    <em>Texto en cursiva</em>
                  </td>
                </tr>
                <tr>
                  <td>&lt;i&gt;&lt;/i&gt;</td>
                  <td>Texto en cursiva (no semántico).</td>
                  <td>
                    <i>Texto en cursiva</i>
                  </td>
                </tr>
                <tr>
                  <td>&lt;b&gt;&lt;/b&gt;</td>
                  <td>Texto en negrita (no semántico).</td>
                  <td>
                    <b>Texto en negrita</b>
                  </td>
                </tr>
                <tr>
                  <td>&lt;sup&gt;&lt;/sup&gt;</td>
                  <td>Texto en superíndice.</td>
                  <td>
                    Texto<sup>superíndice</sup>
                  </td>
                </tr>
                <tr>
                  <td>&lt;sub&gt;&lt;/sub&gt;</td>
                  <td>Texto en subíndice.</td>
                  <td>
                    Texto<sub>subíndice</sub>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </DefaultSlide>
        <DefaultSlide title="Elementos semánticos de contenido">
          <div style={{ width: "100%", fontSize: "0.85em" }}>
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Elemento</th>
                  <th>Descripción</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>&lt;div&gt;&lt;/div&gt;</td>
                  <td>Contenedor genérico de bloque.</td>
                </tr>
                <tr>
                  <td>&lt;main&gt;&lt;/main&gt;</td>
                  <td>Contenedor para el contenido principal del sitio.</td>
                </tr>
                <tr>
                  <td>&lt;header&gt;&lt;/header&gt;</td>
                  <td>Encabezado de una sección o página.</td>
                </tr>
                <tr>
                  <td>&lt;footer&gt;&lt;/footer&gt;</td>
                  <td>Pie de página de una sección o página.</td>
                </tr>
                <tr>
                  <td>&lt;section&gt;&lt;/section&gt;</td>
                  <td>Sección temática dentro de un documento.</td>
                </tr>
                <tr>
                  <td>&lt;article&gt;&lt;/article&gt;</td>
                  <td>Contenido independiente y autocontenido.</td>
                </tr>
                <tr>
                  <td>&lt;aside&gt;&lt;/aside&gt;</td>
                  <td>
                    Contenido relacionado tangencialmente con el contenido
                    principal.
                  </td>
                </tr>
                <tr>
                  <td>&lt;nav&gt;&lt;/nav&gt;</td>
                  <td>Sección de navegación.</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div>
            <img src="/images/S02/semantic.jpg" alt="" />
          </div>
        </DefaultSlide>
        <DefaultSlide title="Elementos multimedia">
          <div style={{ width: "100%", fontSize: "0.7em" }}>
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Elemento</th>
                  <th>Descripción</th>
                  <th>Ejemplo</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    &lt;img src="url" alt="texto alternativo"&gt;
                    <br /> (<i>ejemplificaremos cuando la imagen no carga</i>)
                  </td>
                  <td>Imagen.</td>
                  <td>
                    <img
                      src="https://via.placeholder.comrandom/150"
                      alt="texto alternativo"
                    />
                  </td>
                </tr>
                <tr>
                  <td>&lt;audio src="url"&gt;&lt;/audio&gt;</td>
                  <td>Audio.</td>
                  <td>
                    <audio controls>
                      <source
                        src="https://www.w3schools.com/TAGS/horse.mp3"
                        type="audio/mpeg"
                      />
                      Tu navegador no soporta el elemento de audio.
                    </audio>
                  </td>
                </tr>
                <tr>
                  <td>&lt;video src="url"&gt;&lt;/video&gt;</td>
                  <td>Video.</td>
                  <td>
                    <video
                      id="video"
                      controls
                      preload="none"
                      width="300"
                      poster="https://assets.codepen.io/32795/poster.png"
                    >
                      <source
                        id="mp4"
                        src="http://media.w3.org/2010/05/sintel/trailer.mp4"
                        type="video/mp4"
                      />
                      <source
                        id="webm"
                        src="http://media.w3.org/2010/05/sintel/trailer.webm"
                        type="video/webm"
                      />
                      <source
                        id="ogv"
                        src="http://media.w3.org/2010/05/sintel/trailer.ogv"
                        type="video/ogg"
                      />

                      <track
                        kind="subtitles"
                        label="English subtitles"
                        src="subtitles_en.vtt"
                        srcLang="en"
                        default
                      ></track>

                      <track
                        kind="subtitles"
                        label="Deutsche Untertitel"
                        src="subtitles_de.vtt"
                        srcLang="de"
                      ></track>
                      <p>
                        Your user agent does not support the HTML5 Video
                        element.
                      </p>
                    </video>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </DefaultSlide>
        <DefaultSlide title="Elementos para tablas">
          <div style={{ width: "40%", fontSize: "0.85em" }}>
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Elemento</th>
                  <th>Descripción</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>&lt;table&gt;&lt;/table&gt;</td>
                  <td>Tabla.</td>
                </tr>
                <tr>
                  <td>&lt;tr&gt;&lt;/tr&gt;</td>
                  <td>Fila de la tabla.</td>
                </tr>
                <tr>
                  <td>&lt;th&gt;&lt;/th&gt;</td>
                  <td>Celda de encabezado.</td>
                </tr>
                <tr>
                  <td>&lt;td&gt;&lt;/td&gt;</td>
                  <td>Celda de datos.</td>
                </tr>
                <tr>
                  <td>&lt;thead&gt;&lt;/thead&gt;</td>
                  <td>Encabezado de la tabla.</td>
                </tr>
                <tr>
                  <td>&lt;tbody&gt;&lt;/tbody&gt;</td>
                  <td>Cuerpo de la tabla.</td>
                </tr>
                <tr>
                  <td>&lt;tfoot&gt;&lt;/tfoot&gt;</td>
                  <td>Pie de la tabla.</td>
                </tr>
              </tbody>
            </table>
            <p>
              Para la celda de una fila con otra se utiliza rowspan y para unir
              dos columnas colspan.
            </p>
          </div>
          <div>
            <img
              src="/images/S02/table.png"
              alt="Ejemplo de una table en HTML."
            />
          </div>
        </DefaultSlide>
        <DefaultSlide title="Elementos para formularios">
          <div style={{ width: "100%", fontSize: "0.85em" }}>
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Elemento</th>
                  <th>Descripción</th>
                  <th>Ejemplo</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>&lt;form&gt;&lt;/form&gt;</td>
                  <td>Formulario.</td>
                  <td></td>
                </tr>
                <tr>
                  <td>&lt;input&gt;</td>
                  <td>Campo de entrada.</td>
                  <td>
                    <input type="text" placeholder="Nombre" />
                  </td>
                </tr>
                <tr>
                  <td>&lt;textarea&gt;&lt;/textarea&gt;</td>
                  <td>Área de texto.</td>
                  <td>
                    <textarea placeholder="Escribe aquí..."></textarea>
                  </td>
                </tr>
                <tr>
                  <td>&lt;select&gt;&lt;/select&gt;</td>
                  <td>Lista desplegable.</td>
                  <td>
                    <select>
                      <option>Opción 1</option>
                      <option>Opción 2</option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <td>&lt;option&gt;&lt;/option&gt;</td>
                  <td>Opción dentro de una lista desplegable.</td>
                  <td></td>
                </tr>
                <tr>
                  <td>&lt;button&gt;&lt;/button&gt;</td>
                  <td>Botón.</td>
                  <td>
                    <button type="submit">Click me</button>
                  </td>
                </tr>
                <tr>
                  <td>&lt;input type="number"&gt;</td>
                  <td>Campo de entrada numérico.</td>
                  <td>
                    <input type="number" placeholder="Número" />
                  </td>
                </tr>
                <tr>
                  <td>&lt;input type="range"&gt;</td>
                  <td>Control deslizante.</td>
                  <td>
                    <input type="range" />
                  </td>
                </tr>
                <tr>
                  <td>&lt;input type="password"&gt;</td>
                  <td>Contraseña</td>
                  <td>
                    <input type="password" />
                  </td>
                </tr>
                <tr>
                  <td>&lt;input type="date"&gt;</td>
                  <td>Campo de entrada de fecha.</td>
                  <td>
                    <input type="date" />
                  </td>
                </tr>
                <tr>
                  <td>&lt;input type="time"&gt;</td>
                  <td>Campo de entrada de hora.</td>
                  <td>
                    <input type="time" />
                  </td>
                </tr>
                <tr>
                  <td>&lt;input type="email"&gt;</td>
                  <td>Campo de entrada de correo electrónico.</td>
                  <td>
                    <input type="email" placeholder="correo@ejemplo.com" />
                  </td>
                </tr>
                <tr>
                  <td>&lt;input type="url"&gt;</td>
                  <td>Campo de entrada de URL.</td>
                  <td>
                    <input type="url" placeholder="https://ejemplo.com" />
                  </td>
                </tr>
                <tr>
                  <td>&lt;input type="color"&gt;</td>
                  <td>Selector de color.</td>
                  <td>
                    <input type="color" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </DefaultSlide>
        <DefaultSlide title="¿Por qué utilizar componentes semánticos?">
          <div style={{ width: "35%", fontSize: "0.7em" }}>
            <p>
              Los elementos semánticos son importantes porque ayudan a los
              navegadores y motores de búsqueda a entender el contenido de una
              página web. Esto mejora la accesibilidad y la optimización para
              motores de búsqueda (SEO).
            </p>
          </div>
          <div>
            <img
              src="/images/S02/semantic.png"
              alt="Comparación entre el uso de DIVs y componentes semánticos."
            />
          </div>
        </DefaultSlide>
      </section>
      <section>
        <TitleSlide title="HTML en profundidad">
          <a href="https://html.spec.whatwg.org/multipage/">
            https://html.spec.whatwg.org/multipage/
          </a>
        </TitleSlide>

        <DefaultSlide title="¿Cómo funciona HTML?">
          <div style={{ width: "100%", fontSize: "0.7em" }}>
            <p>
              ¿Recuerdan el curso de estructuras de datos? Pues básicamente un
              documento HTML es una estructura de árbol concida como DOM
              (Document Object Model).
            </p>
            <img src="/images/S02/domtree.jpg" alt="Imagen de DOM Tree" />
          </div>
        </DefaultSlide>
        <DefaultSlide title="Visualizando el DOM">
          <div style={{ width: "50%", fontSize: "0.7em" }}>
            <p>
              Veamos un ejemplo básico con una estructura sencilla de HTML. ¡Ha
              llegado la hora de abrir las herramientas de desarrollador por
              segunda vez!
            </p>
            <pre>
              <code data-trim className="language-html">
                {`<!DOCTYPE html>
<html>
  <head>
  <title>Ejemplo básico</title>
  </head>
  <body>
  <h1>Hola Mundo</h1>
  <p>Este es un párrafo en un documento HTML.</p>
  <ul>
    <li>Elemento 1</li>
    <li>Elemento 2</li>
    <li>Elemento 3</li>
  </ul>
  </body>
</html>`}
              </code>
            </pre>
          </div>
          <div>
            <img
              src="/images/S02/DOMViewEdge.png"
              alt="Ejemplifica la visualizacion del DOM desde las herramientas de desarrollador de Edge."
            />
          </div>
        </DefaultSlide>
        <DefaultSlide title="¿Cómo funciona HTML?">
          <div style={{ width: "50%", fontSize: "0.7em" }}>
            <p>
              El texto dentro de cualquier elemento se convierte en un nodo
              llamado: TextNode.
            </p>
            <a
              href="https://bioub.github.io/dom-visualizer/"
              target="_blank"
              rel="noreferrer"
            >
              DOM Visualizer
            </a>
            <img
              src="/images/S02/domVisualization.svg"
              alt="Imagen de DOM Tree"
            />
            <a
              href="https://0xedward.github.io/dom-visualizer/"
              target="_blank"
              rel="noreferrer"
            >
              Otra herramienta
            </a>
            <br />
            <a
              href="https://www.fritscher.ch/dom-css/"
              target="_blank"
              rel="noreferrer"
            >
              Otra herramienta con CSS
            </a>
          </div>
        </DefaultSlide>
        <DefaultSlide title="¿Por qué el acento no se ve bien?">
          <div>
            <img
              src="/images/S02/acento.png"
              alt="Imagen con error de visualización de acento."
            />
          </div>
          <div style={{ width: "100%", fontSize: "0.7em" }}>
            <StudentPicker number={1} />
            <p className="fragment">
              Recuerden agregar todos los metadatos. En este caso hizo falta la
              etiqueta <br />
              <code>&lt;meta charset="UTF-8" /&gt;</code>
            </p>
            <p className="fragment">
              Ahora vamos a añadir un elemento &lt;a&gt; al párrafo.
            </p>
          </div>
        </DefaultSlide>
        <DefaultSlide title="El elemento &lt;a&gt; no hace un salto de línea">
          <div>
            <img
              src="/images/S02/acento.png"
              alt="Imagen con error de visualización de acento."
            />
          </div>
          <div style={{ width: "100%", fontSize: "0.7em" }}>
            <StudentPicker number={1} />
            <p className="fragment">
              Recuerden agregar todos los metadatos. En este caso hizo falta la
              etiqueta <br />
              <code>&lt;meta charset="UTF-8" /&gt;</code>
            </p>
            <p className="fragment">
              Ahora vamos a añadir un elemento &lt;a&gt; al párrafo.
            </p>
          </div>
        </DefaultSlide>
        <DefaultSlide title="El elemento &lt;a&gt; no hace un salto de línea">
          <CodePen title="Basic HTML" penId="KwPGQNx" editable />
        </DefaultSlide>
        <DefaultSlide title="Inline vs Block elements">
          <div style={{ width: "100%", fontSize: "0.7em" }}>
            <p>
              Los elementos de bloque ocupan todo el ancho disponible y
              comienzan en una nueva línea. Ejemplos: &lt;div&gt;, &lt;p&gt;,
              &lt;h1&gt;, etc.
            </p>
            <p>
              Los elementos en línea solo ocupan el espacio necesario y no
              comienzan en una nueva línea. Ejemplos: &lt;a&gt;, &lt;span&gt;,
              etc.
            </p>
          </div>
        </DefaultSlide>
        <section>
          <img
            src="/images/S02/inline-vs-block.webp"
            alt="Imagen comparativa de elementos bloque vs en la misma línea."
          />
        </section>
      </section>
      <section>
        <h3>¿Cómo nos sentimos?</h3>
        <p>
          Hemos terminado con los contenidos de HTML más generales. Aún hay
          muchísimo más que podríamos ver, pero ha llegado la hora de movernos a
          CSS.
        </p>
        <img
          className="fragment"
          src="/images/S02/css-peter.gif"
          alt="Meme CSS"
        />
      </section>

      <section>
        <TitleSlide title="Introducción a CSS">
          <a href="https://www.w3.org/Style/CSS/">
            https://www.w3.org/Style/CSS/
          </a>
        </TitleSlide>
        <DefaultSlide title="¿Qué es CSS?">
          <div style={{ width: "30%", fontSize: "0.7em" }}>
            <p>
              CSS (Cascading Style Sheets) es un lenguaje de diseño utilizado
              para describir la presentación de un documento HTML. Permite
              controlar el diseño, los colores, las fuentes y otros aspectos
              visuales de una página web.
            </p>
          </div>
          <div>
            <img
              style={{ margin: "0 0 0 20px" }}
              src="/images/S02/htmlcss.png"
              alt="CSS meme."
            />
          </div>
        </DefaultSlide>
        <DefaultSlide title="Versiones de CSS">
          <div style={{ width: "100%", fontSize: "0.7em" }}>
            <p>
              CSS ha evolucionado a lo largo del tiempo, y actualmente existen
              varias versiones:
            </p>
            <ul>
              <li>CSS1: Primera versión, lanzada en 1996.</li>
              <li>CSS2: Lanzada en 1998, introdujo nuevas características.</li>
              <li>CSS3: Lanzada en 1999, dividida en módulos.</li>
              <li className="fragment">
                CSS4: Many people are waiting for CSS4 to come out. Where is it?
                When will it arrive? The answer is never. CSS4 will never
                happen. It’s not actually a thing.{" "}
                <a href="https://css-tricks.com/css4/">
                  https://css-tricks.com/css4/
                </a>
              </li>
            </ul>
          </div>
        </DefaultSlide>
        <section>
          <img src="/images/S02/cssevolution.png" alt="CSS evolution" />
        </section>
        <DefaultSlide title="¿Cómo funciona CSS?">
          <div style={{ width: "100%", fontSize: "1em" }}>
            <p>
              CSS se aplica a los elementos HTML mediante selectores. Los
              selectores permiten seleccionar elementos específicos y aplicarles
              estilos.
            </p>
            <p>
              Los estilos se pueden aplicar de tres maneras: en línea, en la
              sección <code>&lt;head&gt;</code> del documento o en un archivo
              CSS externo.
            </p>
            <pre>
              <code className="hljs language-css" data-trim data-line-numbers>
                {`p {
  color: red;
}`}
              </code>
            </pre>
          </div>
        </DefaultSlide>
        <DefaultSlide title="Formas de aplicar CSS">
          <div style={{ width: "100%", fontSize: "0.7em" }}>
            <p>Hay tres formas de aplicar CSS a un documento HTML:</p>
            <pre>
              <code
                className="hljs language-html"
                data-trim
                data-line-numbers="5-13|15|18"
              >
                {`<!DOCTYPE html>
<html>
<head>
  <title>Ejemplo de CSS</title>
  <style>
    /* CSS Interno */
    body {
      font-family: Arial, sans-serif;
    }
    h1 {
      color: blue;
    }
  </style>
  <!-- Some other text -->
  <link rel="stylesheet" href="styles.css"> <!-- CSS Externo -->
</head>
<body>
  <h1 style="color: red;">Hola Mundo</h1> <!-- CSS en línea -->
  <p>Este es un párrafo.</p>
</body>
</html>`}
              </code>
            </pre>
          </div>
        </DefaultSlide>
        <DefaultSlide title="Identificadores de elementos HTML">
          <div>
            <p>
              Los elementos HTML pueden ser identificados de diferentes formas.
              Estos identificadores son después utilizados en CSS para que a
              través de <em>Selectores</em> se les aplique estilos.
            </p>
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Identificador</th>
                  <th>Descripción</th>
                  <th>Ejemplo</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Clase</td>
                  <td>
                    Selecciona todos los elementos con la clase especificada.
                  </td>
                  <td>
                    <code>&lt;div class="miClase"&gt;&lt;/div&gt;</code>
                  </td>
                </tr>
                <tr>
                  <td>Id</td>
                  <td>Selecciona el elemento con el id especificado.</td>
                  <td>
                    <code>&lt;div id="miIdentificador"&gt;&lt;/div&gt;</code>
                  </td>
                </tr>
              </tbody>
            </table>
            <br />
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Aspecto</th>
                  <th>ID</th>
                  <th>Class</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Unicidad</td>
                  <td>Debe ser único en el documento.</td>
                  <td>Pueden ser reutilizadas en múltiples elementos.</td>
                </tr>
                <tr>
                  <td>Especificidad</td>
                  <td>Mayor especificidad en CSS.</td>
                  <td>Menor especificidad en CSS.</td>
                </tr>
                <tr>
                  <td>Uso</td>
                  <td>Ideal para elementos únicos.</td>
                  <td>Ideal para aplicar estilos a múltiples elementos.</td>
                </tr>
                <tr>
                  <td>Selector en CSS</td>
                  <td>#miIdentificador</td>
                  <td>.miClase</td>
                </tr>
              </tbody>
            </table>
          </div>
        </DefaultSlide>
        <DefaultSlide title="Selectores de CSS">
          <div style={{ width: "100%", fontSize: "0.7em" }}>
            <p>
              Los selectores de CSS permiten seleccionar elementos HTML para
              aplicarles estilos. Se pueden utilizar identificadores de HTML o
              bien otros selectores más específicos:
            </p>
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Selector</th>
                  <th>Descripción</th>
                  <th>Ejemplo</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Selector de etiqueta</td>
                  <td>
                    Selecciona todos los elementos de una etiqueta específica.
                  </td>
                  <td>
                    <code>p &#123; color: red; &#125;</code>
                  </td>
                </tr>
                <tr>
                  <td>Selector de clase</td>
                  <td>
                    Selecciona todos los elementos con una clase específica.
                  </td>
                  <td>
                    <code>.miClase &#123; color: blue; &#125;</code>
                  </td>
                </tr>
                <tr>
                  <td>Selector de ID</td>
                  <td>Selecciona el elemento con un ID específico.</td>
                  <td>
                    <code>#miID &#123; color: green; &#125;</code>
                  </td>
                </tr>
                <tr>
                  <td>Selector de atributo</td>
                  <td>
                    Selecciona todos los elementos con un atributo específico.
                  </td>
                  <td>
                    <code>[type="text"] &#123; color: purple; &#125;</code>
                  </td>
                </tr>
                <tr>
                  <td>Selector de descendiente</td>
                  <td>
                    Selecciona todos los elementos que son descendientes de un
                    elemento específico.
                  </td>
                  <td>
                    <code>div p &#123; color: orange; &#125;</code>
                  </td>
                </tr>
                <tr>
                  <td>Selector de hijo</td>
                  <td>
                    Selecciona todos los elementos que son hijos directos de un
                    elemento específico.
                  </td>
                  <td>
                    <code>div &gt; p &#123; color: pink; &#125;</code>
                  </td>
                </tr>
                <tr>
                  <td>Selector de hermano adyacente</td>
                  <td>
                    Selecciona el elemento que es el siguiente hermano inmediato
                    de un elemento específico.
                  </td>
                  <td>
                    <code>h1 + p &#123; color: brown; &#125;</code>
                  </td>
                </tr>
                <tr>
                  <td>Selector de hermano general</td>
                  <td>
                    Selecciona todos los elementos hermanos de un elemento
                    específico.
                  </td>
                  <td>
                    <code>h1 ~ p &#123; color: gray; &#125;</code>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <aside className="notes">
            {`p {
  text-decoration: underline;
}

.prioritario {
  background-color: red;
}

#mySpecialId {
  color: #FFF;
  background: blue;
}

[type="text"] {
  color: purple;
}

section p {
  border: 2px solid green;
}

section > p {
  color: #FFF;
  background: purple;
}

br + label + input {
  border: 2px solid blue;
}

div ~ p {
  background: orange;
}`}
          </aside>
        </DefaultSlide>
        <section>
          <CodePen title="CSS Selectors" penId="KwKMGpY" editable />
        </section>

        <DefaultSlide title="Combinando selectores">
          <div style={{ width: "100%", fontSize: "0.7em" }}>
            <p>
              Los selectores pueden combinarse para seleccionar elementos más
              específicos.
            </p>
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Selector</th>
                  <th>Descripción</th>
                  <th>Ejemplo</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Selector de clase con etiqueta</td>
                  <td>
                    Selecciona todos los elementos de tipo párrafo con una clase
                    específica.
                  </td>
                  <td>
                    <code>p.miClase &#123; color: red; &#125;</code>
                  </td>
                </tr>
                <tr>
                  <td>Selector de ID con etiqueta</td>
                  <td>
                    Selecciona el elemento de tipo párrafo con un ID específico.
                  </td>
                  <td>
                    <code>p#miID &#123; color: blue; &#125;</code>
                  </td>
                </tr>
                <tr>
                  <td>Selector de atributo con etiqueta</td>
                  <td>
                    Selecciona todos los elementos de tipo párrafo con un
                    atributo específico.
                  </td>
                  <td>
                    <code>p[type="text"] &#123; color: green; &#125;</code>
                  </td>
                </tr>
                <tr>
                  <td>Selector de descendiente con clase</td>
                  <td>
                    Selecciona todos los elementos de tipo párrafo que son
                    descendientes de un elemento con una clase específica.
                  </td>
                  <td>
                    <code>.miClase p &#123; color: orange; &#125;</code>
                  </td>
                </tr>
                <tr>
                  <td>Selector de hijo con clase e ID</td>
                  <td>
                    Selecciona el elemento de tipo párrafo que es hijo de un
                    elemento con una clase e ID específicos.
                  </td>
                  <td>
                    <code>
                      .miClase#miID &gt; p &#123; color: purple; &#125;
                    </code>
                  </td>
                </tr>
                <tr>
                  <td>Selector de hijo con clase, ID y atributo</td>
                  <td>
                    Selecciona el elemento de tipo párrafo que es hijo de un
                    elemento con una clase, ID y atributo específicos.
                  </td>
                  <td>
                    <code>
                      .miClase#miID[type="text"] &gt; p &#123; color: brown;
                      &#125;
                    </code>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>
              El siguiente link tiene muy buenos ejemplos de selectores más
              complejos
            </p>
            <a
              href="https://www.w3schools.com/cssref/trysel.php?"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.w3schools.com/cssref/trysel.php?
            </a>
          </div>
        </DefaultSlide>
        <section>
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Selector</th>
                <th>Descripción</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>.intro</td>
                <td>Selecciona todos los elementos con la clase "intro".</td>
              </tr>
              <tr>
                <td>#Lastname</td>
                <td>Selecciona el elemento con el ID "Lastname".</td>
              </tr>
              <tr>
                <td>.intro, #Lastname</td>
                <td>
                  Selecciona todos los elementos con la clase "intro" y el ID
                  "Lastname".
                </td>
              </tr>
              <tr>
                <td>h1</td>
                <td>Selecciona todos los elementos &lt;h1&gt;.</td>
              </tr>
              <tr>
                <td>h1, p</td>
                <td>Selecciona todos los elementos &lt;h1&gt; y &lt;p&gt;.</td>
              </tr>
              <tr>
                <td>div p</td>
                <td>
                  Selecciona todos los elementos &lt;p&gt; que son descendientes
                  de un &lt;div&gt;.
                </td>
              </tr>
              <tr>
                <td>div &gt; p</td>
                <td>
                  Selecciona todos los elementos &lt;p&gt; que son hijos
                  directos de un &lt;div&gt;.
                </td>
              </tr>
              <tr>
                <td>ul + p</td>
                <td>
                  Selecciona el elemento &lt;p&gt; que es inmediatamente
                  siguiente a un &lt;ul&gt;.
                </td>
              </tr>
              <tr>
                <td>ul ~ table</td>
                <td>
                  Selecciona todos los elementos &lt;table&gt; que son hermanos
                  de un &lt;ul&gt;.
                </td>
              </tr>
              <tr>
                <td>*</td>
                <td>Selecciona todos los elementos.</td>
              </tr>
              <tr>
                <td>p.myquote</td>
                <td>
                  Selecciona todos los elementos &lt;p&gt; con la clase
                  "myquote".
                </td>
              </tr>
              <tr>
                <td>[id]</td>
                <td>Selecciona todos los elementos con un atributo "id".</td>
              </tr>
              <tr>
                <td>[id=my-Address]</td>
                <td>
                  Selecciona el elemento con el atributo "id" igual a
                  "my-Address".
                </td>
              </tr>
              <tr>
                <td>[id$=ess]</td>
                <td>
                  Selecciona todos los elementos con un atributo "id" que
                  termina en "ess".
                </td>
              </tr>
              <tr>
                <td>[id|=my]</td>
                <td>
                  Selecciona todos los elementos con un atributo "id" que
                  empieza con "my".
                </td>
              </tr>
              <tr>
                <td>[id^=L]</td>
                <td>
                  Selecciona todos los elementos con un atributo "id" que
                  empieza con "L".
                </td>
              </tr>
              <tr>
                <td>[title~=beautiful]</td>
                <td>
                  Selecciona todos los elementos con un atributo "title" que
                  contiene la palabra "beautiful".
                </td>
              </tr>
              <tr>
                <td>[id*=s]</td>
                <td>
                  Selecciona todos los elementos con un atributo "id" que
                  contiene la letra "s".
                </td>
              </tr>
              <tr>
                <td>:checked</td>
                <td>Selecciona todos los elementos que están seleccionados.</td>
              </tr>
              <tr>
                <td>:disabled</td>
                <td>
                  Selecciona todos los elementos que están deshabilitados.
                </td>
              </tr>
              <tr>
                <td>:enabled</td>
                <td>Selecciona todos los elementos que están habilitados.</td>
              </tr>
              <tr>
                <td>:empty</td>
                <td>Selecciona todos los elementos que no tienen hijos.</td>
              </tr>
              <tr>
                <td>:focus</td>
                <td>Selecciona el elemento que tiene el foco.</td>
              </tr>
            </tbody>
          </table>
        </section>
        <section>
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Selector</th>
                <th>Descripción</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>p:first-child</td>
                <td>
                  Selecciona todos los elementos &lt;p&gt; que son el primer
                  hijo de su padre.
                </td>
              </tr>
              <tr>
                <td>p::first-letter</td>
                <td>
                  Selecciona la primera letra de todos los elementos &lt;p&gt;.
                </td>
              </tr>
              <tr>
                <td>p::first-line</td>
                <td>
                  Selecciona la primera línea de todos los elementos &lt;p&gt;.
                </td>
              </tr>
              <tr>
                <td>p:first-of-type</td>
                <td>
                  Selecciona todos los elementos &lt;p&gt; que son el primer
                  hijo de su tipo.
                </td>
              </tr>
              <tr>
                <td>h1:hover</td>
                <td>
                  Selecciona todos los elementos &lt;h1&gt; cuando el ratón está
                  sobre ellos.
                </td>
              </tr>
              <tr>
                <td>input:in-range</td>
                <td>
                  Selecciona todos los elementos &lt;input&gt; cuyo valor está
                  dentro de un rango especificado.
                </td>
              </tr>
              <tr>
                <td>input:out-of-range</td>
                <td>
                  Selecciona todos los elementos &lt;input&gt; cuyo valor está
                  fuera de un rango especificado.
                </td>
              </tr>
              <tr>
                <td>input:invalid</td>
                <td>
                  Selecciona todos los elementos &lt;input&gt; con un valor
                  inválido.
                </td>
              </tr>
              <tr>
                <td>input:valid</td>
                <td>
                  Selecciona todos los elementos &lt;input&gt; con un valor
                  válido.
                </td>
              </tr>
              <tr>
                <td>p:lang(it)</td>
                <td>
                  Selecciona todos los elementos &lt;p&gt; con el atributo
                  "lang" igual a "it".
                </td>
              </tr>
              <tr>
                <td>p:last-child</td>
                <td>
                  Selecciona todos los elementos &lt;p&gt; que son el último
                  hijo de su padre.
                </td>
              </tr>
              <tr>
                <td>p:last-of-type</td>
                <td>
                  Selecciona todos los elementos &lt;p&gt; que son el último
                  hijo de su tipo.
                </td>
              </tr>
              <tr>
                <td>tr:nth-child(even)</td>
                <td>
                  Selecciona todos los elementos &lt;tr&gt; que son hijos pares.
                </td>
              </tr>
              <tr>
                <td>tr:nth-child(odd)</td>
                <td>
                  Selecciona todos los elementos &lt;tr&gt; que son hijos
                  impares.
                </td>
              </tr>
              <tr>
                <td>li:nth-child(1)</td>
                <td>
                  Selecciona todos los elementos &lt;li&gt; que son el primer
                  hijo.
                </td>
              </tr>
              <tr>
                <td>li:nth-last-child(1)</td>
                <td>
                  Selecciona todos los elementos &lt;li&gt; que son el último
                  hijo.
                </td>
              </tr>
              <tr>
                <td>li:nth-of-type(2)</td>
                <td>
                  Selecciona todos los elementos &lt;li&gt; que son el segundo
                  hijo de su tipo.
                </td>
              </tr>
              <tr>
                <td>li:nth-last-of-type(2)</td>
                <td>
                  Selecciona todos los elementos &lt;li&gt; que son el penúltimo
                  hijo de su tipo.
                </td>
              </tr>
              <tr>
                <td>b:only-child</td>
                <td>
                  Selecciona todos los elementos &lt;b&gt; que son el único hijo
                  de su padre.
                </td>
              </tr>
              <tr>
                <td>h3:only-of-type</td>
                <td>
                  Selecciona todos los elementos &lt;h3&gt; que son el único
                  hijo de su tipo.
                </td>
              </tr>
              <tr>
                <td>:root</td>
                <td>Selecciona el elemento raíz del documento.</td>
              </tr>
            </tbody>
          </table>
        </section>
        <DefaultSlide title="Estructura de reglas para CSS">
          <div style={{ width: "100%", fontSize: "1em" }}>
            <p>
              La estructura básica de una regla CSS consiste en un selector y un
              bloque de declaración.
            </p>
            <pre>
              <code className="hljs language-css" data-trim data-line-numbers>
                {`selector {
  propiedad: valor;
  propiedad: valor;
  propiedad: valor;
}`}
              </code>
            </pre>
          </div>
        </DefaultSlide>
        <section>
          <p>
            Existen muchísimos atributos de CSS que veremos a lo largo del
            curso. La mejor forma de aprenderlos es practicando.
          </p>
        </section>
      </section>

      <section>
        <TitleSlide title="Ejercicio: to-do app" />
        <DefaultSlide title="Ejercicio: to-do app">
          <div style={{ width: "100%", fontSize: "0.7em" }}>
            <p>
              El ejercicio consiste en crear una aplicación de lista de tareas
              (to-do app) utilizando HTML (posteriormente CSS).
            </p>
            <p>
              La aplicación debe permitir al usuario agregar, eliminar y marcar
              tareas como completadas.
            </p>
          </div>
        </DefaultSlide>
        <section>
          <img src="/images/S02/todo.png" alt="UI para aplicación to-do." />
        </section>
        <section>
          <CodePen penId="wBvgBGK" title="To-Do App" editable={false} defaultTab="css"  />
        </section>
        <DefaultSlide title="Tarea. Parte 1">
          <div style={{ width: "100%", fontSize: "0.7em" }}>
            <Alert variant="success">
              Objetivo: Aprender sobre propiedades de CSS. <br />
              <span style={{ fontSize: "0.5em" }}>Vence: 05 Marzo 2025</span>
            </Alert>
            <p>
              En su repositorio de Github, cree un documento HTML llamado
              `tareaPropiedades.html`. En este documento, cree una tabla para
              explicar todas las propiedades de CSS utilizadas en el ejercicio
              anterior. Debe incluir las siguientes columnas:
            </p>
            <ul>
              <li>Nombre de propiedad</li>
              <li>Función</li>
              <li>Posibles valores</li>
            </ul>
            <p>
              Asegurese de subir (git push) el cambio antes de la fecha límite.
            </p>
          </div>
        </DefaultSlide>
        <DefaultSlide title="Tarea. Parte 2">
          <div style={{ width: "100%", fontSize: "0.7em" }}>
            <p>
              Al final del documento HTML, agregue un párrafo explicando por qué
              no fue posible modificar los estilos de los checkboxes durante el
              ejercicio en clase.
            </p>
          </div>
        </DefaultSlide>
        <DefaultSlide title="Ejercicio: to-do app">
          <div style={{ width: "100%", fontSize: "0.7em" }}>
            <p>https://moderncss.dev/pure-css-custom-checkbox-style/</p>
          </div>
        </DefaultSlide>
      </section>
      <ImageSlide image="/images/S02/party-dance.gif" title="¡Fin de la clase!">
        <p>Recuerda completar todos los contenidos de la semana.</p>
        {/* <button className="btn btn-success">Marcar como completo</button> */}
      </ImageSlide>
    </>
  );
}
